import classnames from "classnames";
import React, { ChangeEvent } from "react";

import { IChangeable } from "../Form/components/types";
import { IStyleSize } from "../Style/types";

interface StyleProps extends Partial<IStyleSize> {}

export interface ISwitchProps extends IChangeable, StyleProps {
  disabled?: boolean;
  name?: string;
  value?: boolean | null;
}

export class Switch extends React.PureComponent<ISwitchProps> {
  static defaultProps: Partial<ISwitchProps> = {
    size: "md",
  };

  handleChange(value: boolean) {
    if (this.props.onChange && !this.props.disabled) {
      this.props.onChange(value);
    }
  }

  handleCheckboxChange = (event: ChangeEvent<HTMLInputElement>) => {
    this.handleChange(event.target.checked);
  };

  render() {
    const { name, disabled, value, size } = this.props;

    const className = classnames("el-switch", {
      "el-switch--checked": !!value,
      "el-switch--disabled": !!disabled,
      [`el-switch--size-${size}`]: !!size,
    });

    return (
      <div className={className}>
        <input
          type="checkbox"
          className="el-switch__checkbox"
          onChange={this.handleCheckboxChange}
          name={name}
          disabled={disabled}
          checked={!!value}
        />
        <div className="el-switch__handler" />
      </div>
    );
  }
}
